(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Dinero con el formato de la tienda */
  const money = cents => {
    const fmt = (window.TV && TV.moneyFormat) || '${{amount_no_decimals}}';
    const n = Math.round(cents / 100);
    const dot = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const comma = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals_with_comma_separator' ? dot :
      k === 'amount_no_decimals' ? comma :
      k === 'amount_with_comma_separator' ? dot + ',00' : comma + '.00');
  };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* Toast */
  let tt;
  const toast = msg => { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2600); };

  /* Carrusel: parte en una imagen al azar y avanza sola */
  $$('[data-hero]').forEach(hero => {
    const slides = $$('.slide', hero), dots = $$('.dot', hero);
    if (slides.length < 2) return;
    let i = 0, timer;
    const ms = (parseInt(hero.dataset.interval, 10) || 6) * 1000;
    const go = n => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('on', k === i); s.toggleAttribute('aria-hidden', k !== i); });
      dots.forEach((d, k) => d.classList.toggle('on', k === i));
    };
    const play = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), ms); };
    const stop = () => clearInterval(timer);
    hero.addEventListener('click', e => {
      const d = e.target.closest('[data-dot]'), a = e.target.closest('[data-sl]');
      if (d) { go(+d.dataset.dot); play(); }
      if (a) { go(i + +a.dataset.sl); play(); }
    });
    hero.addEventListener('focusin', e => { if (e.target.matches(':focus-visible')) stop(); });
    hero.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
    go(Math.floor(Math.random() * slides.length));
    play();
  });

  /* Menú móvil y carrito: capas */
  const scrim = $('#scrim'), nav = $('#mnav'), drawer = $('#drawer');
  const closeAll = () => { nav && nav.classList.remove('on'); drawer && drawer.classList.remove('on'); drawer && drawer.setAttribute('aria-hidden', 'true'); scrim && scrim.classList.remove('on'); const mb = $('#menuBtn'); mb && mb.setAttribute('aria-expanded', 'false'); };
  $('#menuBtn') && $('#menuBtn').addEventListener('click', e => { nav.classList.add('on'); scrim.classList.add('on'); e.currentTarget.setAttribute('aria-expanded', 'true'); });
  $('#closeNav') && $('#closeNav').addEventListener('click', closeAll);
  scrim && scrim.addEventListener('click', closeAll);
  $('#closeCart') && $('#closeCart').addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  /* Carrito lateral */
  const renderCart = cart => {
    const n = $('#cartN');
    if (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; }
    const items = $('#items'); if (!items) return;
    items.innerHTML = cart.items.length ? cart.items.map(it => `
      <div class="ci">
        <a href="${it.url}">${it.image ? `<img src="${it.image}&width=200" alt="">` : ''}</a>
        <div><b><a href="${it.url}">${esc(it.product_title)}</a></b>
          ${it.variant_title ? `<small>Talla ${esc(it.variant_title)}</small>` : ''}
          ${it.sku ? `<small>Ref. ${esc(it.sku)}</small>` : ''}
          <button class="rm" type="button" data-rm="${it.key}">Quitar</button></div>
        <span class="precio" style="font-weight:800">${money(it.final_line_price)}</span>
      </div>`).join('') : '<p style="color:var(--texto-2);padding:24px 0">Tu carrito está vacío. Cada disfraz es pieza única: encuéntralo antes de que se lo lleve otro.</p>';
    const sub = $('#sub'); if (sub) sub.textContent = money(cart.total_price);
    const co = $('#checkout'); if (co) co.style.display = cart.item_count ? '' : 'none';
  };
  const openCart = () => { drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); scrim.classList.add('on'); };
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  $('#cartBtn') && drawer && $('#cartBtn').addEventListener('click', e => {
    if (document.body.classList.contains('t-cart')) return;
    e.preventDefault(); getCart().then(c => { renderCart(c); openCart(); });
  });

  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-add]'); if (!f || !drawer) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) { toast(j.description || 'No se pudo agregar. Puede que ya se haya vendido.'); return; }
        if (btn) btn.textContent = '✓ En tu carrito';
        return getCart().then(c => { renderCart(c); openCart(); });
      })
      .catch(() => toast('No se pudo agregar. Intenta de nuevo.'))
      .finally(() => { if (btn) setTimeout(() => (btn.disabled = false), 400); });
  });

  document.addEventListener('click', e => {
    const rm = e.target.closest('[data-rm]'); if (!rm) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: rm.dataset.rm, quantity: 0 }) })
      .then(r => r.json()).then(renderCart);
  });

  /* Colección: ordenar y filtros */
  const sort = $('#sort');
  sort && sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });
  const ff = $('#ff');
  ff && ff.addEventListener('change', e => { if (e.target.type === 'checkbox') ff.requestSubmit ? ff.requestSubmit() : ff.submit(); });
  ff && ff.addEventListener('submit', () => $$('input', ff).forEach(i => { if (i.type === 'number' && !i.value) i.disabled = true; }));
  const fbtn = $('#fbtn'), fl = $('#fl');
  fbtn && fbtn.addEventListener('click', () => { const on = fl.classList.toggle('on'); fbtn.setAttribute('aria-expanded', on); });

  /* Zoom de la foto del producto */
  $$('[data-zoom]').forEach(m => {
    m.addEventListener('click', () => m.classList.toggle('z'));
    m.addEventListener('mousemove', e => { const r = m.getBoundingClientRect(); m.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); m.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
    m.addEventListener('mouseleave', () => m.classList.remove('z'));
  });
})();
